export const getIDs = (orgStageID: string) => {
    let s = orgStageID.split('-')
    return {
        orgID: s[0],
        stageID: s[1],
        stageIndex: +s[1].split('_')[1]
    }
}



export const getPrevStageID = (stageID: string) => {
    let s = stageID.split('_')
    const prevStageID = `${s[0]}_${+s[1]-1}`
    return prevStageID;
} 